import Vue from "vue";
import VS2 from "vue-script2";

Vue.use(VS2);
